import { render, staticRenderFns } from "./ChangeTownForm.vue?vue&type=template&id=38ae82b6&"
import script from "./ChangeTownForm.vue?vue&type=script&lang=js&"
export * from "./ChangeTownForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports